import { render } from "./CancellationRetention.vue?vue&type=template&id=65e7a67c&scoped=true"
import script from "./CancellationRetention.vue?vue&type=script&lang=js"
export * from "./CancellationRetention.vue?vue&type=script&lang=js"

import "./CancellationRetention.vue?vue&type=style&index=0&id=65e7a67c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e7a67c"]])

export default __exports__